import {forEach} from 'lodash';

export default {
  mutateClientRegisterForm(state, data) {
    state.clientRegisterForm = {
      ...state.clientRegisterForm,
      ...data
    };
  },
  clearClientRegisterForm(state) {
    const clientRegisterForm = {...state.clientRegisterForm};
    forEach(clientRegisterForm, (value, key) => {
      clientRegisterForm[key] = null;
    });
    state.clientRegisterForm = {...clientRegisterForm};
  },
  mutateCandidateRegisterForm(state, data) {
    state.candidateRegisterForm = {
      ...state.candidateRegisterForm,
      ...data
    };
  },
  clearCandidateRegisterForm(state) {
    const candidateRegisterForm = {...state.candidateRegisterForm};
    forEach(candidateRegisterForm, (value, key) => {
      candidateRegisterForm[key] = null;
    });
    state.candidateRegisterForm = {...candidateRegisterForm};
  },
  clearRegisterFormError(state) {
    state.registerFormError = null;
  },
  mutateRegisterFormLoading(state, loading) {
    state.registerFormLoading = loading;
  },
  mutateRegisterFormError(state, error) {
    state.registerFormError = error;
  }
};
